const defaultColumns = [
  {
    label: "First Name",
    value: "first_name",
  },
  {
    label: "Middle Name",
    value: "middle_name",
  },
  {
    label: "Last Name",
    value: "last_name",
  },
  {
    label: "Birthdate",
    value: "birthdate",
  },
  {
    label: "Category",
    value: "category",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "Level/Phase/Tier",
    value: "level/phase/tier",
  },
  {
    label: "Street Address",
    value: "street_address",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "State",
    value: "state",
  },
  {
    label: "Zip code",
    value: "zip_code",
  },
  {
    label: "Occupancy Facility Name",
    value: "occ_facility_name",
  },
  {
    label: "Occupancy Admitted At",
    value: "occ_admitted_at",
  },
  {
    label: "Occupancy Discharged At",
    value: "occ_discharged_at",
  },
  {
    label: "Reason for discharge",
    value: "occ_reason_for_discharge",
  },
  {
    label: "Gender",
    value: "gender",
  },
  {
    label: "Marital Status",
    value: "marital_status",
  },
  {
    label: "Race",
    value: "race",
  },
  {
    label: "Ethnicity",
    value: "ethnicity",
  },
  {
    label: "Veteran",
    value: "veteran",
  },
  {
    label: "Sobriety Date",
    value: "sobriety_date",
  },
];

export default defaultColumns;
